<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col text-center">
        <br><br>
        <img src="/img/Logo.png" width="300">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home"
};
</script>
